module.exports = __webpack_public_path__ + "static/media/Picture55.c0f0e954.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Picture55.png
// module id = 1551
// module chunks = 0